import Vue from 'vue'
import TopBanner from './TopBanner'
import Title from './Title'

Vue.component('top-banner', TopBanner);
Vue.component('section-title', Title);